import Skeleton from "react-loading-skeleton";
import { FieldHeader } from "@/shared/ui";
export function IncidentOverviewSkeleton() {
  return <div className="flex gap-6 items-start w-full pb-4 text-tremor-default" data-sentry-component="IncidentOverviewSkeleton" data-sentry-source-file="incident-overview-skeleton.tsx">
      <div className="basis-2/3 grow">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Summary</FieldHeader>
            <Skeleton count={3} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
          </div>
          <div className="flex flex-col gap-2">
            <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Involved services</FieldHeader>
            <div className="flex flex-wrap gap-1">
              <Skeleton width={80} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
              <Skeleton width={100} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
              <Skeleton width={90} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
            </div>
          </div>
          <div>
            <Skeleton count={2} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
          </div>
          <div>
            <Skeleton count={2} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
          </div>
        </div>
      </div>
      <div className="pr-10 grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div className="xl:col-span-2">
          <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Status</FieldHeader>
          <Skeleton height={38} data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
        </div>
        <div>
          <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Last Incident Activity</FieldHeader>
          <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
        </div>
        <div>
          <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Started at</FieldHeader>
          <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
        </div>
        <div>
          <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Assignee</FieldHeader>
          <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
        </div>
        <div>
          <FieldHeader data-sentry-element="FieldHeader" data-sentry-source-file="incident-overview-skeleton.tsx">Group by value</FieldHeader>
          <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="incident-overview-skeleton.tsx" />
        </div>
      </div>
    </div>;
}